import { useParams } from "react-router-dom";
import { useState, useCallback } from "react";
import { useEffect } from "react";
import { openAlert, openConfirm } from "../../utils/common";
import SectionContainer from "../../components/UI/SectionContainer";
import Spinner from "../../components/UI/Spinner";
import Modal from "../../components/Layout/Modal";
import fingerprintService from "../../services/fingerprintService";

const UserFingerprintPage = () => {
    const {userIdx} = useParams();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);  

    const [selectedIds, setSelectedIds] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fingerprintData, setFingerprintData] = useState({
        userIdx: "",
        deviceId: "",
        manufacturerName: "",
        modelNumber: "",
        serialNumber: "",
        fingerprintIdx: "",
    });

    //체크박스 전체 선택
    const handleCheckAll = (e) => {
        if (e.target.checked) {
          // 모든 아이디를 한꺼번에 추가
          setSelectedIds(list.map((item) => item.userIdx+','+item.deviceId));
        } else {
          setSelectedIds([]);
        }
    };

    //체크박스 개별 선택
    const handleCheck = (id, checked) => {
        setSelectedIds(prev =>
            checked
              ? [...prev, id]
              : prev.filter(itemId => itemId !== id)
        );
    };

    const fetchUserFingerprintList = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fingerprintService.getUserFingerprintList(userIdx);
            
            if (response.success) {
                setList(response.data || []);
            } else {
                openAlert({ title: '알림', description: response.message || '데이터 로드 중 오류가 발생했습니다.' });
            }
        } catch (e) { 
            const errorMessage = e.response?.data?.message || e.message || '데이터 로드 중 오류가 발생했습니다.';
            openAlert({ title: '알림', description: errorMessage });
        } finally {
            setLoading(false);
        }
    }, [userIdx]);

    useEffect(() => {
        fetchUserFingerprintList();
    }, [fetchUserFingerprintList]); // eslint-disable-line react-hooks/exhaustive-deps

    const requestDeleteFingerprint = useCallback(async () => {
        try {
            // 개별 삭제를 순차적으로 수행
            for (const fingerprintId of selectedIds) {
                const [userIdx, deviceId] = fingerprintId.split(',');
                await fingerprintService.deleteFingerprint(userIdx, deviceId);
            }
            
            setSelectedIds([]);
            openAlert({ title: '알림', description: "지문이 삭제되었습니다.", response_method: "fetchUserFingerprintList" });
        } catch (e) { 
            const errorMessage = e.response?.data?.message || e.message || '데이터 로드 중 오류가 발생했습니다.';
            openAlert({ title: '알림', description: errorMessage });
        } finally {
            setLoading(false);
        }
    }, [selectedIds]);
    

    const requestDeleteFingerprintConfirm = () => {
        if(selectedIds.length === 0){
            openAlert({title:"알림", description: "삭제할 지문을 선택해주세요."});
            return;
        }
        openConfirm({
            title: "삭제",
            description: "선택하신 지문을 삭제하시겠습니까?",
            positive_method : "requestDeleteFingerprint",
            positive_btn : "확인",
            negative_btn : "취소",
        });
    }

    useEffect(() => {
        window.fetchUserFingerprintList = fetchUserFingerprintList;
        window.requestDeleteFingerprint = requestDeleteFingerprint;
        return () => {
            delete window.fetchUserFingerprintList;
            delete window.requestDeleteFingerprint;
        }
    }, [fetchUserFingerprintList, requestDeleteFingerprint]);

    const openEditFingerprintModal = (item) => {
        setFingerprintData(item);
        setIsModalVisible(true);
    }

    const onEditFingerprint = async () => {
        if(!fingerprintData.manufacturerName || !fingerprintData.modelNumber || !fingerprintData.serialNumber || fingerprintData.fingerprintIdx === ""){
            openAlert({title:"알림", description: "자세한 정보를 입력해 주세요."});
            return;
        }

        if (Number(fingerprintData.fingerprintIdx) > 9) {
            openAlert({title:"알림", description: "Index 값은 0~9 사이여야 합니다."});
            return;
        }

        setLoading(true);
        try{
            const updateData = {
                manufacturerName: fingerprintData.manufacturerName,
                modelNumber: fingerprintData.modelNumber,
                serialNumber: fingerprintData.serialNumber,
                fingerprintIdx: fingerprintData.fingerprintIdx
            };
            
            const result = await fingerprintService.updateFingerprint(
                fingerprintData.userIdx, 
                fingerprintData.deviceId, 
                updateData
            );
            
            if(!result.success){
                openAlert({title:"알림", description: result.message || '지문 수정 중 오류가 발생했습니다.'});
                return;
            }
            closeEditFingerprintModal();
            openAlert({title:"알림", description: "지문 등록정보가 수정되었습니다.", response_method: "fetchUserFingerprintList"});
        }catch(e){
            console.log(e);
            openAlert({title:"알림", description: "지문 등록정보를 수정하는 중 오류가 발생했습니다."});
        }finally{
            setLoading(false);
        }
    }

    const closeEditFingerprintModal = () => {
        setIsModalVisible(false);
    }

    const numberCheck = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        setFingerprintData({
            ...fingerprintData,
            fingerprintIdx: value,
        });
    }

    return (
        <SectionContainer title="지문 관리">
            <Spinner loading={loading} />
            <div className="search_area" style={{alignItems: 'flex-start'}}>
                <div></div>

                <div className="left">
                    <div className="xlsx-wrap insert-wrap">
                        <input type="button" 
                            className="btn btn-md primary mr-1" 
                            style={{backgroundColor: '#ff2b2b'}} 
                            value="지문 삭제" 
                            onClick={requestDeleteFingerprintConfirm} 
                        />   
                    </div> 
                </div>
            </div>
            <div className="account_content">
                <div className="content_area con01">
                    <div className="table_area popup_table_area">
                        <div className="table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>                                                
                                            <div className="input">
                                                <input type="checkbox" 
                                                    checked={selectedIds.length === list.length && list.length>0}
                                                    onChange={handleCheckAll}
                                                    id="allCheckElem" />
                                            </div>
                                        </th>
                                        <th>Manufacturer</th>
                                        <th>Model</th>
                                        <th>Serial</th>
                                        <th>Index</th>
                                    </tr>
                                </thead>
                                <tbody id="wrap" data-wrap="wrap">
                                    {!loading && list.length === 0 ? (
                                        <tr className="view_none" id="noPost">
                                            <td colSpan="5">회원 내역이 존재하지 않습니다.</td>
                                        </tr>
                                    ) : (
                                        !loading && list.map((item, index) => (
                                            <tr key={index} onClick={() => openEditFingerprintModal(item)}>
                                            <td>
                                                <div className="input">
                                                    <input type="checkbox" 
                                                        checked={selectedIds.includes(item.userIdx+','+item.deviceId)}
                                                        onChange={(e) => {
                                                            handleCheck(item.userIdx+','+item.deviceId, e.target.checked);
                                                            e.stopPropagation();
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                </div>
                                            </td>
                                            <td data-attr="manufacturer_name">{item.manufacturerName}</td>
                                            <td data-attr="model_number">{item.modelNumber}</td>
                                            <td data-attr="serial_number">{item.serialNumber}</td>
                                            <td data-attr="fingerprint_idx">{item.fingerprintIdx}</td>
                                        </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Modal  
                title="지문 관리"
                className="terminal-info mt-2"
                modalClassName=" modal-ml"
                onConfirm={onEditFingerprint}
                confirmLabel="수정"
                onClose={closeEditFingerprintModal}
                visible={isModalVisible}
            >             
                <dl>
                    <dt>Manufacturer</dt>
                    <dd>
                        <input type="text" name="manufacturer_name" onChange={(e) => setFingerprintData({ ...fingerprintData, manufacturerName: e.target.value })} value={fingerprintData.manufacturerName} />
                    </dd>
                </dl>
                <dl>
                    <dt>Model</dt>
                    <dd>
                        <input type="text" name="model_number" onChange={(e) => setFingerprintData({ ...fingerprintData, modelNumber: e.target.value })} value={fingerprintData.modelNumber} />
                    </dd>
                </dl>
                <dl>
                    <dt>Serial</dt>
                    <dd>
                        <input type="text" name="serial_number" onChange={(e) => setFingerprintData({ ...fingerprintData, serialNumber: e.target.value })} value={fingerprintData.serialNumber} />
                    </dd>
                </dl>

                <dl>
                    <dt>Index</dt>
                    <dd>
                        <input type="text" name="fingerprint_idx" value={fingerprintData.fingerprintIdx} onChange={numberCheck} />
                    </dd>
                </dl>
            </Modal>
            
        </SectionContainer>
    );
}   

export default UserFingerprintPage;